import CrudTable from "components/table/CrudTable";
import React, { useEffect, useState } from "react";
import { useToast } from "context/toast-context/ToastProvider";
import ToastMessage from "components/Dialog/ToastMessage";
import { useCookies } from "react-cookie";
import {
  createEventType,
  deleteEventType,
  fetchEventTypes,
  updateEventType,
} from "ServerAPI/serverAPI";
import EventTypesForm from "./EventTypesForm";

const EventTypes = () => {
  const [rows, setRows] = useState([]);
  const { showToast } = useToast();
  const [showToastMessage, setShowToastMessage] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cookies] = useCookies();
  const [buttonLoading, setButtonLoading] = useState(false);

  const handleToastMessageClose = () => {
    setShowToastMessage(false);
  };

  const columns = [
    {
      field: "sno",
      headerName: "S.No",
      width: 70,
      align: "center",
      headerAlign: "center",
      headerClassName: "table-header",
      editable: false,
    },
    {
      field: "title",
      headerName: "Name",
      flex: 1,
      minWidth: 180,
      align: "center",
      headerAlign: "center",
      headerClassName: "table-header",
      editable: false,
      renderCell: (params) => {
        if (!params.value) return "";
        return params.value
          .toString()
          .split(" ")
          .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
          .join(" ");
      },
    },
  ];

  const handlefetchAcademicYears = async () => {
    const payload = {
      userId: cookies.userId,
    };
    setLoading(true);
    if (payload && payload.userId) {
      const response = await fetchEventTypes(payload);
      if (response && response.status === "success") {
        const rowsWithSno = (response.data || []).map((row, index) => ({
          ...row,
          sno: index + 1,
        }));
        setRows(rowsWithSno || []);
        setLoading(false);
      } else {
        setRows([]);
        setLoading(false);
        showToast(response?.message || "Failed to fetch Event Types", "error");
      }
    } else {
      setRows([]);
      setLoading(false);
    }
  };

  useEffect(() => {
    handlefetchAcademicYears();
  }, [cookies.userId]);

  const handlecreateEventType = async (data) => {
    const payload = {
      userId: cookies.userId,
      title: data.title,
    };
    setButtonLoading(true);
    const response = await createEventType(payload);
    if (response && response.status === "success") {
      setRows((prevRows) => {
        const updated = [response.data, ...prevRows];
        return updated.map((row, index) => ({ ...row, sno: index + 1 }));
      });
      setButtonLoading(false);
      showToast("Event Type Created Successfully", "success");
      return true;
    } else {
      setButtonLoading(false);
      showToast(response?.message || "Failed to create Event Type", "error");
      return false;
    }
  };

  const handleDeleteEventType = async (data) => {
    const payload = {
      userId: cookies.userId,
      eventTypeId: data.eventTypeId,
      mode: "delete",
    };
    setLoading(true);
    const response = await deleteEventType(payload);
    if (response && response.status === "success") {
      setRows((prevRows) => {
        const filtered = prevRows.filter(
          (row) => row.eventTypeId !== payload.eventTypeId,
        );
        return filtered.map((row, index) => ({ ...row, sno: index + 1 }));
      });
      setLoading(false);
      showToast("Event Type Deleted Successfully", "success");
      return true;
    } else {
      setLoading(false);
      showToast(response?.message || "Failed to delete Event Type", "error");
      return false;
    }
  };

  const handleUpdateEventType = async (data) => {
    const payload = {
      userId: cookies.userId,
      mode: "edit",
      ...data,
    };
    setButtonLoading(true);
    const response = await updateEventType(payload);
    if (response && response.status === "success") {
      setRows((prevRows) => {
        const updated = prevRows.map((row) => {
          if (row.eventTypeId === data.eventTypeId) {
            return response.data;
          }
          return row;
        });
        return updated.map((row, index) => ({ ...row, sno: index + 1 }));
      });
      setButtonLoading(false);
      showToast("Event Type Updated Successfully", "success");
      return true;
    } else {
      setButtonLoading(false);
      showToast(response?.message || "Failed to update Event Type", "error");
      return false;
    }
  };

  return (
    <div className="container ms-auto my-5">
      <ToastMessage
        open={showToastMessage}
        message="Course Marked As Deleted"
        closeTiming={3000}
        handleClose={handleToastMessageClose}
      />
      <CrudTable
        rows={rows}
        columns={columns}
        onRefresh={handlefetchAcademicYears}
        loading={loading}
        createButtonText={"Create Event Type"}
        FormComponent={EventTypesForm}
        deleteButtonText={"Delete Event Type"}
        handleSubmit={handlecreateEventType}
        buttonLoading={buttonLoading}
        getRowId={(row) => row.eventTypeId}
        handleDelete={handleDeleteEventType}
        onUpdate={handleUpdateEventType}
        disable={cookies.roleId !== "organizationCoordinator"}
      />
    </div>
  );
};

export default EventTypes;
